import React from 'react';
import ReactHighcharts from 'react-highcharts';
import _ from 'lodash';

class LineChart extends React.Component {

    constructor(props) {
        super(props);

        const { widget } = props;

        this.state = {
            width: widget.width,
            height: widget.height,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { width, height } = nextProps.widget;

        if (width !== nextState.width || height !== nextState.height) {
            this.setState({width, height});

            return true;
        }

        return !(_.isEqual(this.props, nextProps));
    }

    render() {
        const { widget, widgetData, isThumbnail } = this.props;

        if (!widgetData.length) {
            return null;
        }

        var config = {
            chart: {
                renderTo: 'container',
            },
            title: {
                text: widget.displayConfig.customTitle,
            },
            xAxis: {
                type: 'datetime',
                tickInterval: 30 * 24 * 3600 * 1000,
            },
            yAxis: {
                title: {
                    text: '$',
                },
            },
            credits: {
                enabled: false,
            },
            plotOptions: {
                line: {
                    lineWidth: 3,
                },
            },
            series: [],
        };

        _.each(widgetData, (serie) => {
            config.series.push({
                name: serie.name,
                type: 'line',
                data: serie.data,
            });
        });

        return (
            <div>
                {!isThumbnail && <ReactHighcharts config={config} isPureConfig />}
            </div>
        );
    }

}

LineChart.propTypes = {
    widget: React.PropTypes.object,
    widgetData: React.PropTypes.array,
};

export default LineChart;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/LineChart.jsx
 **/